import { useUserContext } from '@fortem-monorepo/react-spa'

export type ContentBlockRenderContext = {
  userContext: ReturnType<typeof useUserContext>
}

export const ContentBlockContextProvider: React.FC<{
  children: (context: ContentBlockRenderContext) => React.ReactNode
}> = ({ children }) => {
  const userContext = useUserContext()

  return children({ userContext })
}
